const If = ({ test, children }) => (test ? children : false)

export default If


// WEBPACK FOOTER //
// src/utils/If.js